import * as React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';

interface WrapperForSafariBorderRadiusBugProps {
  boxShadowStyle: {
    style: object
  }
  borderRadius: number
}

const createStyle = (borderRadius: number) => StyleSheet.create({
  wrapper: {
    display: 'flex',
    width: '100%',
    height: '100%',
    borderRadius: `${borderRadius}px`,
  },
});

export const WrapperForSafariBorderRadiusBug: React.FunctionComponent<WrapperForSafariBorderRadiusBugProps> = ({ boxShadowStyle, children, borderRadius }) => {
  const style = createStyle(borderRadius);
  return (
    <div className={css(boxShadowStyle.style, style.wrapper)}>
      {children}
    </div>
  );
};
